/** @file StaleBuildToast: the sticky "newer Pose3D is live" toast; Reload is the user's choice. */
import type { ReactElement } from 'react';

/** One toast in the stack; `onReload` is the only way the page reloads (default `location.reload`). */
export function StaleBuildToast({ onReload = () => { globalThis.location.reload(); } }: { onReload?: () => void }): ReactElement {
  return (
    <div className="p3-toast p3-toast-warning" role="status" data-testid="stale-build-toast">
      <span>A newer Pose3D is live — Reload</span>
      <button type="button" className="p3-btn" onClick={onReload}>Reload</button>
    </div>
  );
}
